export default __webpack_public_path__ + "static/media/card-data.c3c0c5d1.png";